export const CURRENT_MODEL_VERSION = '1.5.0';
